import { render, staticRenderFns } from "./numberkeyboard.vue?vue&type=template&id=fd18319c&"
import script from "./numberkeyboard.vue?vue&type=script&lang=js&"
export * from "./numberkeyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports